import React, { useState } from 'react'
import { Form, Cascader, Card, Picker, DatePicker, Input, Button } from 'antd-mobile';
import moment from 'moment';
import { labelRenderer } from 'utils/ruleType';
import { keysConstant } from 'utils/constant/key';
import { tableNameConstant } from 'utils/constant/tableName';
import { postNameConstant } from 'utils/constant/postName';
import { formType } from 'utils/constant';

const { T_DIC_PROTECH, T_DIC_PROQUALITY, T_DIC_AREACODE } = keysConstant
const { FJOBLEVEL, FPROTECH, FJOBINTENT, FOBJECTIVE, FWORKEXPER, FEDUEXPER, FCERTIFICATE } = tableNameConstant
const { FCAREOBJECT, FINTENPROVINCE, PLACE, FINTENCITY, FFINTENCOUNTY, FCAREOBJCITY, FCAREOBJCOUN } = postNameConstant
const { INPUT, PICKER, CHOOSE, DATEPICKER, CASCADER } = formType


const KEY = 'key'

/**
 * 失业表单填写联级选择模板
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 *  getSkillObj,getUserObj,getPostObj,getJobWantedObj:根据传入的tableName,获取数据,插入到areaContent中
 *  skillContent,content,postContent,jobWantContent:联级选择框内数据
 * } props
 * @returns
 */
export function BpmFormManyCascader(props) {
  const { tableName, count, option } = props.item
  const { skillContent, getSkillObj, getUserObj, content,
    setFormInfo, getPostObj, postContent, setSkillContent,
    jobWantContent, setJobWantContent, getJobWantedObj,
    form, setPostContent, setContent, postInfo } = props

  const [visible, setVisible] = useState(false)

  const getPartData = (arr) => {
    let newArr = []
    for (let i = 0; i < count.length; i++) {
      newArr.push({})
      arr.forEach(item => {
        switch (item) {  // 有一些特殊字段做特殊处理
          case FCAREOBJECT:
          case FINTENPROVINCE:
            return newArr[i][item] = T_DIC_AREACODE
          default:
            return newArr[i][item] = null
        }
      })
      newArr[i][KEY] = i + 1
      if (postInfo && postInfo[tableName]) {
        // 循环postInfo[tableName]
        postInfo[tableName].forEach((item, index) => {
          if (item[KEY] === newArr[i][KEY]) {
            newArr[i] = item
          }
        })
      }
    }
    return newArr
  };

  const partArr = {
    professionArr: ['FPROQUALITY', 'FPROQUALITYLEVEL'],
    postArr: ['FPROTECH', 'FPROTECHLEVEL'],
    jobWantedArr: ['FJOBINTEN', PLACE, FINTENPROVINCE, 'FSALARYPACK', FFINTENCOUNTY, FINTENCITY],
    jobWantedArr2: ['FINTEJOB', FCAREOBJECT, FCAREOBJCITY, FCAREOBJCOUN, 'FEXPSALARY'],
    workArr: ['FFRWOHOUR', 'FENWOHOUR', 'FCOMNAME', 'FJOBTITLE', 'FWOINTRO'],
    educationArr: ['FFOSCHHOUR', 'FEnSchHou', 'FSCHNAME', 'FEDUBACK', 'FUNIFMO', 'FPROTITLE'],
    certificatesArr: ['FCERTNAME', 'FCERTNUM']
  }

  const { professionArr, postArr, jobWantedArr, jobWantedArr2, workArr, educationArr, certificatesArr } = partArr

  const [professionDatas] = useState(getPartData(professionArr));
  const [postDatas] = useState(getPartData(postArr));
  // 意向岗位
  const [jobWantedDatas] = useState(getPartData(jobWantedArr));
  // 我要招人意向岗位
  const [jobWantedDatas2] = useState(getPartData(jobWantedArr2));
  // 工作经验
  const [workDatas] = useState(getPartData(workArr));
  // 教育经历
  const [educationDatas] = useState(getPartData(educationArr));
  // 证书
  const [certificatesDatas] = useState(getPartData(certificatesArr));

  function getName(key, idx) {
    return `${tableName}-${key}-${idx}`
  }

  /** 设置具体字段的自定义规则 */
  function stateRule(idx, state) {
    return Object.keys(state[idx]).some(key => {
      if (key === KEY) return false
      if (state === jobWantedDatas && key === FINTENPROVINCE) return false
      if (state === jobWantedDatas2 && key === FCAREOBJECT) return false
      return state[idx][key] !== null
    })
  }

  function setRule(idx, other) {
    switch (tableName) {
      case FJOBLEVEL:
        return stateRule(idx, professionDatas)
      case FPROTECH:
        return stateRule(idx, postDatas)
      case FJOBINTENT:
        return stateRule(idx, jobWantedDatas)
      case FOBJECTIVE:
        return stateRule(idx, jobWantedDatas2)
      case FWORKEXPER:
        return stateRule(idx, workDatas)
      case FEDUEXPER:
        return stateRule(idx, educationDatas)
      case FCERTIFICATE:
        return stateRule(idx, certificatesDatas)
      default:
        return null
    }
  }

  /** 判断数组对象内是否存在null,返回数组对象内没有null的值 */
  function judgerNull(arr) {
    return arr.filter(item => {
      for (let i in item) {
        if (item[i] === null) {
          return false
        }
      }
      return true
    })
  }

  function updateFormInfo(idx, postName, datas, value) {
    datas[idx][postName] = value  // 更新数组内储存的值
    const newDatas = judgerNull(datas)  // 筛除空值
    setFormInfo(tableName, newDatas)  // 更新表单储存的数据
  }

  /** 点击 确认按钮/清除按钮 更新数据 */
  function handleOnConfirm(value, idx, postName, infoType) {
    const deleteValue = value === 'delete'  // 是否清空数据
    const newValue = deleteValue ? null : value[value?.length - 1]
    const newIsArrayValue = (Array.isArray(value) || deleteValue) ? newValue : value  // 是不是数组
    const newIsDateValue = (infoType !== DATEPICKER || deleteValue) ? newIsArrayValue : moment(value).format('YYYY-MM-DD')   // 是不是显示日期
    switch (tableName) {
      case FJOBLEVEL:
        updateFormInfo(idx, postName, professionDatas, newValue)
        break
      case FPROTECH:
        updateFormInfo(idx, postName, postDatas, newValue)
        break
      case FJOBINTENT:
        if (postName === PLACE) {
          jobWantedDatas[idx][FINTENCITY] = deleteValue ? null : value[0]
          jobWantedDatas[idx][FFINTENCOUNTY] = deleteValue ? null : value[1]
        }
        updateFormInfo(idx, postName, jobWantedDatas, newIsArrayValue)
        break
      case FOBJECTIVE:
        if (postName === PLACE) {
          jobWantedDatas2[idx][FCAREOBJCITY] = deleteValue ? null : value[0]
          jobWantedDatas2[idx][FCAREOBJCOUN] = deleteValue ? null : value[1]
        }
        delete jobWantedDatas2[idx][PLACE]
        updateFormInfo(idx, postName, jobWantedDatas2, newIsArrayValue)
        break
      case FWORKEXPER:
        updateFormInfo(idx, postName, workDatas, newIsDateValue)
        break
      case FEDUEXPER:
        updateFormInfo(idx, postName, educationDatas, newIsDateValue)
        break
      case FCERTIFICATE:
        updateFormInfo(idx, postName, certificatesDatas, newIsArrayValue)
        break
      default:
        return null
    }
  }

  function handleOnSelect(extend, key, postName) {
    setTimeout(() => {
      key === T_DIC_PROQUALITY && getSkillObj(extend.items, key, skillContent, setSkillContent)
      key === T_DIC_PROTECH && getPostObj(extend.items, key, postContent, setPostContent)
      postName === PLACE && getJobWantedObj(extend.items, jobWantContent, setJobWantContent)
    })
  }

  function handlePickerClick(PickerRef, item, idx) {
    getUserObj(item.api, item.key, getName(item.postName, idx), content, setContent)
    PickerRef.current?.open()
  }

  // 清空数据
  const handleDelete = (idx, option, index) => {
    option.forEach(item => {
      // 根据item.key和idx找到对应的数据
      const data = getName(item.postName, idx)
      // 根据option的type类型判断数据类型
      switch (item.infoType) {
        case INPUT:
          form.setFieldsValue({
            [data]: '',
          });
          break
        case DATEPICKER:
          form.setFieldsValue({
            [data]: null,
          });
          break
        default:
          form.setFieldsValue({
            [data]: [],
          });
      }
      handleOnConfirm('delete', idx, item.postName)
    })
  }

  const handleVisitClick = (item, idx, state) => {
    setVisible({ ...visible, [getName(item.postName, idx)]: state })
  }

  /** 联级选择框数据 */
  const cascaderOptions = (item) => {
    return (
      item.key === T_DIC_PROQUALITY ? skillContent :
        item.key === T_DIC_PROTECH ? postContent :
          item.postName === PLACE ? jobWantContent :
            [{ label: '暂无数据' }]
    )
  }

  /** 表单显示类型 */
  const showFormInfo = (item, idx) => {
    const { infoType, postName, key } = item
    switch (infoType) {
      case CASCADER:
        return (
          <Form.Item
            name={getName(postName, idx)}
            label={item.label}
            rules={[{ required: setRule(idx, item.other), message: item.message }]}
            trigger='onConfirm'
            onClick={() => {
              handleVisitClick(item, idx, true)
            }}
          >
            <Cascader
              options={cascaderOptions(item)}
              visible={visible[getName(postName, idx)]}
              onClose={() => {
                handleVisitClick(item, idx, false)
              }}
              onConfirm={value => {
                handleOnConfirm(value, idx, postName)
              }}
              onSelect={(v, extend) => {
                handleOnSelect(extend, key, postName)
              }}
            >
              {
                value => (
                  value.every(value => value === null) ? '请选择' : value[value.length - 1]?.label
                )
              }
            </Cascader>
          </Form.Item>
        )
      case PICKER:
        return (
          <Form.Item
            name={getName(postName, idx)}
            label={item.label}
            rules={[{ required: setRule(idx, item.other), message: item.message }]}
            trigger='onConfirm'
            onClick={(e, PickerRef) => {
              handlePickerClick(PickerRef, item, idx)
            }}
          >
            <Picker
              title='请选择'
              columns={[content[getName(postName, idx)] ?? [{ label: '暂无数据' }]]}
              onConfirm={value => {
                handleOnConfirm(value, idx, postName)
              }}
            >
              {
                value => (
                  (value.length && value[0].label !== '暂无数据') ? value[0].label : '请选择'
                )
              }
            </Picker>
          </Form.Item>
        )
      case INPUT:
        return (
          <Form.Item
            name={getName(postName, idx)}
            label={item.label}
            rules={[{ required: setRule(idx, item.other), message: item.message }]}
          //trigger='onBlur'
          >
            <Input
              className='inputTextAlign'
              placeholder={item.message}
              onChange={value => {
                handleOnConfirm(value, idx, postName)
              }}
            />
          </Form.Item>
        )
      case DATEPICKER:
        const handleDate = (date, item, idx) => {
          const { postName } = item
          //根据postName获取对应的数据
          const newDatas = tableName === 'FWORKEXPER' ? workDatas : educationDatas
          const formDate = newDatas[idx] && newDatas[idx][postName] ? newDatas[idx][postName] : null
          if (date) {
            if (date instanceof Date) {
              const newDate = moment(date).format('YYYY-MM-DD')
              return newDate
            } else {
              return date
            }
          } else if (formDate) {
            return formDate
          }
          else {
            return item.placeholder
          }
        }
        return (
          < Form.Item
            name={getName(postName, idx)}
            label={item.label}
            disabled={item.disabled}
            rules={[{ required: setRule(idx, item.other), message: item.message, type: Object }]}
            onClick={() => {
              handleVisitClick(item, idx, true)
            }}
            help={item.help ? item.help : ''}
          >
            <DatePicker
              //min={before ? new Date(1900, 1, 1) : new Date()}
              min={new Date(1900, 1, 1)}
              max={item.before ? new Date() : new Date(2100, 1, 1)}
              title={item.pickerTitle}
              visible={visible[getName(postName, idx)]}
              onClose={() => {
                handleVisitClick(item, idx, false)
              }}
              onConfirm={value => {
                handleOnConfirm(value, idx, postName, item.infoType)
              }}
              renderLabel={labelRenderer}
            >
              {value => handleDate(value, item, idx)}
            </DatePicker>
          </Form.Item >
        )
      case CHOOSE:
        return (
          <Form.Item
            name={getName(postName, idx)}
            label={item.label}
            rules={[{ required: setRule(idx, item.other), message: item.message }]}
            trigger='onConfirm'
            onClick={() => handleVisitClick(item, idx, true)}
          >
            <Picker
              title={item.pickerTitle}
              columns={item.option}
              visible={visible[getName(postName, idx)]}
              onConfirm={value => {
                handleOnConfirm(value[0], idx, postName, item.infoType)
              }}
              onClose={() => handleVisitClick(item, idx, false)}
            >
              {
                value => (
                  (value.length && value[0].label !== '暂无数据') ? value[0].label : item.placeholder
                )
              }
            </Picker>
          </Form.Item>
        )
      default:
        return null
    }
  }

  return (
    <>
      {
        count.map((idx, index) =>
          <Card className='formCard' key={index} >
            {
              option.map((item, index) =>
                <div key={index}>
                  {showFormInfo(item, idx)}
                </div>
              )
            }
            <div
              className='formCard-footer'
              onClick={e => e.stopPropagation()}
            >
              <Button
                size='mini'
                onClick={() => {
                  handleDelete(idx, option, index)
                }}
              >
                清除信息
              </Button>
            </div>
          </Card>
        )
      }
    </>
  )
}